import React from 'react'
import './style.scss'
import Web3 from 'web3';
import { useConnectWallet } from '../../hooks/useConnectWallet'

  
  const SignInForm = ({onSingnIn}) => {
    // const {
    //   signInWithMatamark
    //  } = useConnectWallet()

    // const onSingnIn = () => {
    //      signInWithMatamark()
    //  }

    
    return (
      <div className='container'>
        <div className='header header--sign-in'>
          <h1 className='title title--sign-in'>Referral Program</h1>
          <p className='sub-title sub-title--sign-in'>
            Earn money by driving traffic and prompting sales across one of the
            world's best crypto
          </p>
          <button className='btn header--button active' onClick={onSingnIn}>
            Open Dashboard
          </button>
        </div>
      </div>
    )
  }

  export default SignInForm
  